import { useTrackPage } from '@utilitywarehouse/tracking-react';
import { useEffect, useRef, useState } from 'react';

/**
 * Custom hook for tracking page views with duplicate prevention
 * @param pageName - The name of the page to track
 * @param initialTracked - Optional initial state for testing (defaults to false)
 */
export const usePageTracking = (pageName: string, initialTracked = false) => {
  const hasTrackedPage = useRef(initialTracked);
  const [isTracked, setIsTracked] = useState(initialTracked);
  const trackPage = useTrackPage();

  useEffect(() => {
    const shouldTrack = !hasTrackedPage.current;
    hasTrackedPage.current = true;
    setIsTracked(true);

    if (shouldTrack) {
      trackPage(pageName);
    }
  }, [pageName, trackPage]);

  return isTracked;
};
